export default "__VITE_ASSET__m7m0_VT1__"